import { Component } from '@angular/core';

import { PageNavigationService } from '../../services/page-navigation.service';
import { LayoutService } from '../../services/layout.service';

@Component({
    selector: 'sub-header',
    templateUrl: 'sub-header.component.html'
})

export class SubHeaderComponent {

    vActiveItem:string;

    constructor(
		private _pageNavigationService: PageNavigationService,
        private _layoutService: LayoutService
    ){ }

    getSubHeaderStatus() {
        return this._layoutService.vLayoutState.appSubHeader;
    }

    getSubHeaderItemShow(){
        return this._layoutService.vSubHeaderItem;
    }
    
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/header/sub-header.component.ts